import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { darken } from 'polished';

import { COLOR_THEME } from '../utils/themer';
import { BLACK, LIGHT_GREY } from '../constants/colors';

const Button = styled.button`
  height: 40px;
  padding: 11px 15px;
  background: none;
  border-radius: 2px;
  border: 1px solid ${darken(0.3, LIGHT_GREY)};
  color: ${BLACK};
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  margin-left: 15px;

  & span {
    margin-left: 5px;
    @media screen and (max-width: 1170px) {
      display: none;
    }
  }
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${COLOR_THEME.primary};
`;

function ActionButton({
  action, icon, text, id,
}) {
  return (
    <Button type="button" id={id} onClick={action}>
      <StyledIcon icon={icon} />
      <span>{text}</span>
    </Button>
  );
}

ActionButton.propTypes = {
  action: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
};

export default ActionButton;
